webpackJsonp([1],{

/***/ "1Wdm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "24kz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2lMp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5AqT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "71Lg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome/components/Icon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ var Icon = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4061c7f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome/components/Icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome/components/Icon.vue
function injectStyle (ssrContext) {
  __webpack_require__("5AqT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Icon,
  components_Icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_components_Icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J/Ki":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/utils/index.js
/* harmony default export */ var utils = ({
  breakpoints: {
    xs: {
      min: 0,
      max: 767
    },
    sm: {
      min: 768,
      max: 991
    },
    md: {
      min: 992,
      max: 1199
    },
    lg: {
      min: 1200,
      max: 1920
    },
    xl: {
      min: 1921,
      max: Infinity
    }

  },
  breakpoint: function breakpoint(width) {
    var breakpoints = this.breakpoints;
    function withinBreakpoint(breakpointName, width) {
      return width >= breakpoints[breakpointName].min && width <= breakpoints[breakpointName].max;
    }
    if (withinBreakpoint('xs', width)) {
      return 'xs';
    }
    if (withinBreakpoint('sm', width)) {
      return 'sm';
    }
    if (withinBreakpoint('md', width)) {
      return 'md';
    }
    if (withinBreakpoint('lg', width)) {
      return 'lg';
    }
    if (withinBreakpoint('xl', width)) {
      return 'xl';
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'app',
  created: function created() {
    var _this = this;

    this.$store.commit('setBreakpoint', utils.breakpoint(window.innerWidth));
    window.addEventListener('resize', function () {
      var breakpoint = utils.breakpoint(window.innerWidth);
      if (!_this.breakpointIs(breakpoint)) _this.$store.commit('setBreakpoint', breakpoint);
    });
    this.$store.dispatch('GET_PROJECTS');
    if (this.isReturningUser) {
      if (this.hasMultipleProjects) {
        var projectId = this.projectIds[0];
        this.$store.commit('setActiveProjectId', projectId);
        this.$store.dispatch('GET_PROJECT_DATA', { id: projectId });
      } else {
        this.$store.commit('setActiveProjectId', this.projectIds[0]);
      }
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isReturningUser', 'breakpointIs', 'projectIds', 'hasMultipleProjects']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5fee26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("24kz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// CONCATENATED MODULE: ./src/store/state.js
/* harmony default export */ var store_state = ({
  active: {
    modal: '',
    tab: '',
    projectId: '',
    dataGroupId: ''
  },
  projects: {},
  breakpoint: ''
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/utils/templates.js
var templates_project = {
  name: '',
  dataGroups: {},
  userStories: {},
  userJourneys: {}
};

/* harmony default export */ var templates = ({
  project: templates_project
});
// CONCATENATED MODULE: ./src/store/getters.js



/* harmony default export */ var store_getters = ({
  devMode: function devMode() {
    return "production" === 'development';
  },
  isNewUser: function isNewUser(state) {
    return keys_default()(state.projects).length === 0;
  },
  isReturningUser: function isReturningUser(state, getters) {
    return !getters.isNewUser;
  },
  regex: function regex() {
    return {
      isProject: /^proj_/
    };
  },
  hasMultipleProjects: function hasMultipleProjects(state, getters) {
    return keys_default()(state.projects).length > 1;
  },
  dataGroup: function dataGroup(state, getters) {
    return state.active.dataGroupId ? getters.project.dataGroups[state.active.dataGroupId] : null;
  },
  project: function project(state) {
    return state.projects[state.active.projectId];
  },
  projectIds: function projectIds(state) {
    return keys_default()(state.projects);
  },
  projectNames: function projectNames(state, getters) {
    return getters.projectIds.map(function (projectId) {
      return state.projects[projectId].name;
    });
  },
  projectMap: function projectMap(state, getters) {
    var projects = {};
    getters.projectIds.map(function (projectId) {
      projects[projectId] = state.projects[projectId].name;
    });
    return projects;
  },
  template: function template() {
    return templates;
  },
  modalShowing: function modalShowing(state) {
    var isOpen = function isOpen(modalName) {
      return state.active.modal === modalName;
    };
    return {
      addProject: isOpen('addProject'),
      switchProject: isOpen('switchProject'),
      renameProject: isOpen('renameProject'),
      addDataGroup: isOpen('addDataGroup'),
      editDataGroup: isOpen('editDataGroup')
    };
  },


  /**
   * @param {String} breakpoint String
   */
  breakpointIs: function breakpointIs(state) {
    return function () {
      for (var _len = arguments.length, breakpoints = Array(_len), _key = 0; _key < _len; _key++) {
        breakpoints[_key] = arguments[_key];
      }

      return breakpoints.includes(state.breakpoint);
    };
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  name: 'home',
  data: function data() {
    return {
      newProjectName: '',
      typing: false
    };
  },
  mounted: function mounted() {
    this.$store.commit('setActiveTab', 'home');
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['projectNames', 'isNewUser', 'isReturningUser', 'template', 'project']), Object(vuex_esm["e" /* mapState */])(['projects']), {
    total: function total() {
      return {
        dataGroups: keys_default()(this.project.dataGroups).length,
        userStories: keys_default()(this.project.userStories).length,
        userJourneys: keys_default()(this.project.userJourneys).length
      };
    },
    validationChecks: function validationChecks() {
      return {
        hasName: this.newProjectName !== '',
        nameIsUnique: !values_default()(this.projects).includes(this.newProjectName),
        typing: this.typing
      };
    },
    errors: function errors() {
      var errors = [];
      var check = this.validationChecks;
      if (check.typing) {
        if (!check.hasName) {
          errors.push({ text: 'You need to enter a name for your project to continue', type: 'warning' });
        }
        if (!check.nameIsUnique) {
          errors.push({ text: 'Project name already exists', type: 'danger' });
        }
      }
      return errors;
    },
    validated: function validated() {
      return !values_default()(this.validationChecks).includes(false);
    }
  }),
  methods: {
    addProject: function addProject() {
      this.$store.dispatch('ADD_PROJECT', {
        name: this.newProjectName
      });
      this.reset();
    },
    reset: function reset() {
      this.newProjectName = '';
      this.typing = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392306e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{staticClass:"home"},[_c('el-row',[(_vm.isReturningUser)?_c('el-col',[(_vm.project)?_c('el-row',{staticStyle:{"padding-top":"2em"}},[_c('el-col',{attrs:{"span":8}},[_c('span',{staticClass:"U--color-orange"},[_c('b',[_vm._v("Total")]),_vm._v(" Data Groups:")]),_vm._v(" "),(_vm.total.dataGroups)?_c('span',[_vm._v(_vm._s(_vm.total.dataGroups))]):_c('span',{staticClass:"U--dull-if-null"},[_vm._v("none")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('span',{staticClass:"U--color-orange"},[_c('b',[_vm._v("Total")]),_vm._v(" User Stories:")]),_vm._v(" "),(_vm.total.userStories)?_c('span',[_vm._v(_vm._s(_vm.total.userStories))]):_c('span',{staticClass:"U--dull-if-null"},[_vm._v("none")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('span',{staticClass:"U--color-orange"},[_c('b',[_vm._v("Total")]),_vm._v(" User Journeys:")]),_vm._v(" "),(_vm.total.userJourneys)?_c('span',[_vm._v(_vm._s(_vm.total.userJourneys))]):_c('span',{staticClass:"U--dull-if-null"},[_vm._v("none")])])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isNewUser)?_c('el-col',{staticClass:"setup",attrs:{"sm":10,"md":8}},[_c('h3',[_vm._v("To get started, simply choose a name for your first project:")]),_vm._v(" "),_c('div',{staticClass:"add-new-project"},[_c('el-input',{staticClass:"project-name__input",on:{"blur":function($event){_vm.typing = true}},nativeOn:{"~keydown":function($event){_vm.typing = true}},model:{value:(_vm.newProjectName),callback:function ($$v) {_vm.newProjectName=$$v},expression:"newProjectName"}}),_vm._v(" "),_c('p',{staticClass:"project-name__errors"},_vm._l((_vm.errors),function(error,index){return _c('el-tag',{key:index,attrs:{"type":error.type,"size":"mini"}},[_vm._v(_vm._s(error.text))])})),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","disabled":!_vm.validated},on:{"click":_vm.addProject}},[_vm._v("Create")])],1)]):_vm._e()],1)],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/pages/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("iedY")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-392306e4"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_pages_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BtnAddDataGroup.vue

//
//
//
//
//
//



/* harmony default export */ var BtnAddDataGroup = ({
  name: 'btn-add-data-group',
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['openModal']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1381d4dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BtnAddDataGroup.vue
var BtnAddDataGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"U--margin-auto U--unset-float",attrs:{"lg":6,"md":8,"sm":10}},[_c('el-button',{staticClass:"U--full-width",attrs:{"type":"warning","plain":""},nativeOn:{"click":function($event){_vm.openModal('addDataGroup')}}},[_vm._v("Add Data Group")])],1)}
var BtnAddDataGroup_staticRenderFns = []
var BtnAddDataGroup_esExports = { render: BtnAddDataGroup_render, staticRenderFns: BtnAddDataGroup_staticRenderFns }
/* harmony default export */ var components_BtnAddDataGroup = (BtnAddDataGroup_esExports);
// CONCATENATED MODULE: ./src/components/BtnAddDataGroup.vue
var BtnAddDataGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BtnAddDataGroup___vue_template_functional__ = false
/* styles */
var BtnAddDataGroup___vue_styles__ = null
/* scopeId */
var BtnAddDataGroup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BtnAddDataGroup___vue_module_identifier__ = null
var BtnAddDataGroup_Component = BtnAddDataGroup_normalizeComponent(
  BtnAddDataGroup,
  components_BtnAddDataGroup,
  BtnAddDataGroup___vue_template_functional__,
  BtnAddDataGroup___vue_styles__,
  BtnAddDataGroup___vue_scopeId__,
  BtnAddDataGroup___vue_module_identifier__
)

/* harmony default export */ var src_components_BtnAddDataGroup = (BtnAddDataGroup_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/utils/mixins.js



var redirectIfNewUser = {
  created: function created() {
    var isHomeRoute = this.$route.name === 'home';
    if (!isHomeRoute && this.$store.getters.isNewUser) {
      this.$router.push({ name: 'home' });
    }
  }
};

var mixins_objectsMatch = {
  methods: {
    objectsMatch: function objectsMatch(obj1, obj2) {
      return stringify_default()(obj1) === stringify_default()(obj2);
    }
  }
};

var closeModal = {
  methods: {
    closeModal: function closeModal() {
      var activePropToBeSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (activePropToBeSet) {
        activePropToBeSet = activePropToBeSet.charAt(0).toUpperCase() + activePropToBeSet.slice(1);
        this.$store.commit('setActive' + activePropToBeSet, null);
      }
      this.$store.commit('closeModal');
    }
  }
};

var addEditDataGroup = {
  methods: {
    startTyping: function startTyping(key) {
      this.properties[key].new = false;
    },
    addProperty: function addProperty() {
      var id = String(Date.now());
      this.$set(this.properties, id, {
        id: id,
        value: '',
        new: true,
        _isNew: function _isNew() {
          return this.new;
        },
        _hasNoName: function _hasNoName() {
          return this.value === '';
        }
      });
    },
    removeProperty: function removeProperty(key) {
      this.$delete(this.properties, key);
    }
  },
  computed: {
    modalWidth: function modalWidth() {
      return this.breakpointIs('xs') ? '90%' : '500px';
    },
    nonUniqueProperties: function nonUniqueProperties() {
      var _this = this;

      var propertiesMap = {};
      keys_default()(this.properties).forEach(function (propKey) {
        propertiesMap[_this.properties[propKey].value] ? propertiesMap[_this.properties[propKey].value] = 'not unique' : propertiesMap[_this.properties[propKey].value] = 'unique';
      });
      keys_default()(propertiesMap).forEach(function (propKey) {
        if (propertiesMap[propKey] === 'unique' || propKey === '') delete propertiesMap[propKey];
      });
      return keys_default()(propertiesMap);
    },
    validationChecks: function validationChecks() {
      var _this2 = this;

      return {
        hasName: this.name !== '',
        typing: this.typing === true,
        propertyNamesAreUnique: !this.nonUniqueProperties.length > 0,
        nameIsUnique: !keys_default()(this.project.dataGroups).filter(function (key) {
          return _this2.active.dataGroupId !== key;
        }).map(function (key) {
          return _this2.project.dataGroups[key].name;
        }).includes(this.name),
        allPropertiesHaveNames: this.properties && !this.propertyNames.includes(''),
        nonNewpropertiesHaveNames: this.properties && !this.nonNewPropertyNames.includes(''),
        hasChanges: this.mode === 'edit' ? !this.objectsMatch(this.updatedDataGroup.name, this.dataGroup.name) || !this.objectsMatch(this.properties, this.dataGroup.properties) : null
      };
    },
    errors: function errors() {
      var name = [],
          properties = [];

      var check = this.validationChecks;
      if (check.typing) {
        // name
        if (!check.hasName) {
          name.push({ text: 'You must supply a name', icon: '' });
        }
        if (!check.nameIsUnique) {
          name.push({ text: 'Name already exists', icon: '' });
        }
        // properties
        if (!check.nonNewpropertiesHaveNames) {
          properties.push({ text: 'All properties must be named', icon: 'exclamation-triangle' });
        }
        if (!check.propertyNamesAreUnique) {
          properties.push({ text: 'Properties [' + this.nonUniqueProperties.join('] [') + '] are not unique', icon: 'clone' });
        }
      }
      return {
        name: name,
        properties: properties
      };
    },
    validated: function validated() {
      return !values_default()(this.validationChecks).includes(false);
    },
    hasProperties: function hasProperties() {
      return this.propertyNames.length > 0;
    },
    propertyNames: function propertyNames() {
      var _this3 = this;

      return keys_default()(this.properties).map(function (key) {
        return _this3.properties[key].value;
      });
    },
    nonNewPropertyNames: function nonNewPropertyNames() {
      var _this4 = this;

      return keys_default()(this.properties).filter(function (key) {
        return !_this4.properties[key]._isNew();
      }).map(function (key) {
        return _this4.properties[key].value;
      });
    },
    updatedDataGroup: function updatedDataGroup() {
      return {
        id: this.id,
        name: this.name,
        properties: this.properties
      };
    }
  }
};


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Modal/ConfigDataGroup.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ConfigDataGroup = ({
  name: 'modal-config-data-group',
  mixins: [closeModal, addEditDataGroup],
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      id: null,
      name: null,
      properties: {},
      typing: !this.mode === 'add' || this.mode === 'edit'
    };
  },
  created: function created() {
    var _this = this;

    switch (this.mode) {
      case 'add':
        this.id = String(Date.now());
        break;
      case 'edit':
        this.id = this.dataGroup.id;
        this.name = this.dataGroup.name;
        this.properties = assign_default()({}, this.dataGroup.properties);
        keys_default()(this.properties).forEach(function (key) {
          _this.properties[key] = assign_default()({}, _this.properties[key], {
            _isNew: function _isNew() {
              return this.new;
            },
            _hasNoName: function _hasNoName() {
              return this.value === '';
            }
          });
        });
        break;
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['SET_PROJECT_DATA']), {
    hasNoName: function hasNoName(property) {
      return property.new ? false : property.value === '';
    },
    isUnique: function isUnique(name) {
      return name !== '' ? !this.nonUniqueProperties.includes(name) : true;
    },
    addDataGroup: function addDataGroup() {
      var _this2 = this;

      var dataGroups = assign_default()({}, this.project.dataGroups);
      dataGroups[this.id] = {
        id: this.id,
        name: this.name,
        properties: assign_default()({}, this.properties)
      };
      var project = assign_default()({}, this.project, { dataGroups: dataGroups });
      this.SET_PROJECT_DATA(project).then(function (_) {
        _this2.$message({ message: _this2.name + ' successfully added', type: 'success' });
      });
      this.closeModal();
    },
    saveDataGroup: function saveDataGroup() {
      var _this3 = this;

      var dataGroups = assign_default()({}, this.project.dataGroups);
      dataGroups[this.id] = assign_default()({}, this.updatedDataGroup);
      var project = assign_default()({}, this.project, { dataGroups: dataGroups });
      this.SET_PROJECT_DATA(project).then(function (_) {
        _this3.$message({ message: _this3.name + ' successfully updated', type: 'success' });
      });
      this.closeModal('dataGroupId');
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['active']), Object(vuex_esm["c" /* mapGetters */])(['project', 'dataGroup', 'breakpointIs']), {
    showModal: function showModal() {
      return this.mode === 'add' ? this.active.modal === 'addDataGroup' : this.active.modal === 'editDataGroup';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc0c882","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/ConfigDataGroup.vue
var ConfigDataGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{class:(_vm.mode + "-data-group"),attrs:{"title":(_vm.mode + " data group"),"visible":_vm.showModal,"width":_vm.modalWidth,"close-on-click-modal":false},on:{"close":function($event){_vm.closeModal('dataGroupId')}}},[_c('span',[_c('el-row',{staticClass:"section",attrs:{"type":"flex"}},[_c('el-col',[_c('span',{staticClass:"subtitle required"},[_vm._v("Name")]),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-input',{staticClass:"centered",nativeOn:{"~keydown":function($event){_vm.typing = true},"~blur":function($event){_vm.typing = true}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"name"}})],1),_vm._v(" "),_c('el-row',{staticClass:"error__wrapper"},_vm._l((_vm.errors.name),function(error,index){return _c('el-tag',{key:("name_error_" + index),attrs:{"type":"danger"}},[_vm._v(_vm._s(error.text))])}))],1)],1),_vm._v(" "),_c('el-row',{staticClass:"section"},[_c('el-col',[(_vm.hasProperties)?_c('span',{staticClass:"subtitle"},[_vm._v("Properties")]):_vm._e(),_vm._v(" "),(_vm.hasProperties)?_vm._l((_vm.properties),function(property,key){return _c('el-row',{key:key,staticClass:"no-gutter",attrs:{"type":"flex"}},[(property._isNew())?_c('icon',{staticStyle:{"color":"yellowgreen","position":"absolute","z-index":"100","left":"-5px","top":"-2px"},attrs:{"name":"leaf"}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","display":"flex","flex":"1 1 0%"}},[_c('el-input',{class:['property-input', {'has-errors': !_vm.isUnique(property.value) || _vm.hasNoName(property)}],attrs:{"placeholder":""},nativeOn:{"~keydown":function($event){_vm.startTyping(key)}},model:{value:(property.value),callback:function ($$v) {_vm.$set(property, "value", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"property.value"}}),_vm._v(" "),(_vm.nonUniqueProperties.includes(property.value))?_c('icon',{staticStyle:{"position":"absolute","color":"tomato","right":"0.75em","top":"0.75em"},attrs:{"name":"clone"}}):_vm._e(),_vm._v(" "),(!property._isNew() && property._hasNoName())?_c('icon',{staticStyle:{"position":"absolute","color":"tomato","right":"0.75em","top":"0.85em"},attrs:{"name":"exclamation-triangle"}}):_vm._e()],1),_vm._v(" "),_c('el-button-group',{staticClass:"joint-input"},[_c('el-button',{staticClass:"remove",attrs:{"type":"warning","plain":""},on:{"click":function($event){_vm.removeProperty(key)}}},[_c('icon',{attrs:{"name":"minus","scale":"0.75"}})],1),_vm._v(" "),_c('el-button',{staticClass:"add",attrs:{"type":"warning","plain":"","disabled":property === ''},on:{"click":function($event){_vm.addProperty()}}},[_c('icon',{attrs:{"name":"plus","scale":"0.75"}})],1)],1)],1)}):[_c('el-row',{staticClass:"no-gutter",attrs:{"type":"flex"}},[_c('el-button',{staticClass:"U--full-width",attrs:{"type":"warning","plain":"","disabled":!_vm.typing},nativeOn:{"click":function($event){_vm.addProperty()}}},[_vm._v("Add Property")])],1)],_vm._v(" "),_c('el-row',{staticClass:"error__wrapper"},_vm._l((_vm.errors.properties),function(error,index){return _c('el-tag',{key:("property_error_" + index),attrs:{"type":"danger"}},[(error.icon)?_c('icon',{attrs:{"name":error.icon}}):_vm._e(),_vm._v("\n            "+_vm._s(error.text)+"\n          ")],1)}))],2)],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.mode === 'add')?_c('el-button',{staticClass:"U--full-width",attrs:{"plain":"","type":"success","disabled":!_vm.validated},on:{"click":_vm.addDataGroup}},[_vm._v("Add data group")]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit')?_c('el-button',{staticClass:"U--full-width",attrs:{"plain":"","type":"success","disabled":!_vm.validated},on:{"click":_vm.saveDataGroup}},[_vm._v("Save changes")]):_vm._e()],1)])}
var ConfigDataGroup_staticRenderFns = []
var ConfigDataGroup_esExports = { render: ConfigDataGroup_render, staticRenderFns: ConfigDataGroup_staticRenderFns }
/* harmony default export */ var Modal_ConfigDataGroup = (ConfigDataGroup_esExports);
// CONCATENATED MODULE: ./src/components/Modal/ConfigDataGroup.vue
function ConfigDataGroup_injectStyle (ssrContext) {
  __webpack_require__("71Lg")
}
var ConfigDataGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ConfigDataGroup___vue_template_functional__ = false
/* styles */
var ConfigDataGroup___vue_styles__ = ConfigDataGroup_injectStyle
/* scopeId */
var ConfigDataGroup___vue_scopeId__ = "data-v-bcc0c882"
/* moduleIdentifier (server only) */
var ConfigDataGroup___vue_module_identifier__ = null
var ConfigDataGroup_Component = ConfigDataGroup_normalizeComponent(
  ConfigDataGroup,
  Modal_ConfigDataGroup,
  ConfigDataGroup___vue_template_functional__,
  ConfigDataGroup___vue_styles__,
  ConfigDataGroup___vue_scopeId__,
  ConfigDataGroup___vue_module_identifier__
)

/* harmony default export */ var components_Modal_ConfigDataGroup = (ConfigDataGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataGroup.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DataGroup = ({
  name: 'data-group',
  props: {
    dataGroup: {
      type: Object,
      required: true
    }
  },
  components: {
    ModalConfigDataGroup: components_Modal_ConfigDataGroup
  },
  data: function data() {
    return {
      showOptions: false,
      selected: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['active']), Object(vuex_esm["c" /* mapGetters */])(['project', 'modalShowing']), {
    propertyLengthText: function propertyLengthText() {
      return this.propertiesLength === 0 ? 'No properties' : this.propertiesLength === 1 ? '1 property' : this.propertiesLength + ' properties';
    },
    tagType: function tagType() {
      return this.propertiesLength === 0 ? 'info' : 'warning';
    },
    propertiesLength: function propertiesLength() {
      return keys_default()(this.dataGroup.properties).length;
    }
  }),
  methods: {
    openOptions: function openOptions() {
      this.showOptions = true;
    },
    closeOptions: function closeOptions() {
      this.showOptions = false;
      this.selected = null;
    },
    ifSelected: function ifSelected(selection) {
      return { 'active': this.selected === selection };
    },
    editDataGroup: function editDataGroup() {
      this.closeOptions();
      this.$store.commit('setActiveDataGroupId', this.dataGroup.id);
      this.$store.commit('openModal', 'editDataGroup');
    },
    deleteDataGroup: function deleteDataGroup() {
      if (this.selected !== 'delete') this.selected = 'delete'; // acts as a buffer
      else {
          var dataGroups = assign_default()({}, this.project.dataGroups);
          delete dataGroups[this.dataGroup.id];
          var project = assign_default()({}, this.project, { dataGroups: dataGroups });
          this.closeOptions();
          this.$store.dispatch('SET_PROJECT_DATA', project);
          this.$message({ message: 'Deleted dataGroup ' + this.dataGroup.name, type: 'success' });
        }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c8bc5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataGroup.vue
var DataGroup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-group"},[_c('el-row',{nativeOn:{"click":function($event){_vm.openOptions()}}},[_c('el-row',{staticClass:"data-group__title-bar"},[_c('h2',{staticClass:"data-group__name"},[_vm._v(_vm._s(_vm.dataGroup.name))])]),_vm._v(" "),_c('el-tag',{class:['data-group__property-length', {'data-group__property-length--none': Object.keys(_vm.dataGroup.properties).length === 0}],attrs:{"type":_vm.tagType,"size":"mini"}},[_vm._v(_vm._s(_vm.propertyLengthText))]),_vm._v(" "),_c('el-row',{staticClass:"data-group__property-list"},_vm._l((_vm.dataGroup.properties),function(property){return _c('span',{key:property.key,staticClass:"property"},[_vm._v(_vm._s(property.value))])}))],1),_vm._v(" "),(_vm.showOptions)?_c('div',{staticClass:"overlay",on:{"click":_vm.closeOptions}}):_vm._e(),_vm._v(" "),(_vm.showOptions)?_c('el-row',{staticClass:"options-overlay",attrs:{"type":"flex","align":"middle"}},[_c('div',{class:['options-overlay__edit', _vm.ifSelected('edit')],on:{"click":function($event){_vm.editDataGroup()}}},[_c('icon',{attrs:{"name":"pencil-alt","scale":"2"}})],1),_vm._v(" "),_c('div',{class:['options-overlay__delete', _vm.ifSelected('delete')],on:{"click":function($event){_vm.deleteDataGroup()}}},[(_vm.selected !== 'delete')?_c('icon',{attrs:{"name":"trash","scale":"2"}}):_c('span',[_vm._v("Are you sure?")])],1)]):_vm._e(),_vm._v(" "),(_vm.modalShowing.editDataGroup && _vm.dataGroup.id === _vm.active.dataGroupId)?_c('modal-config-data-group',{attrs:{"mode":"edit","dataGroupData":_vm.dataGroup}}):_vm._e()],1)}
var DataGroup_staticRenderFns = []
var DataGroup_esExports = { render: DataGroup_render, staticRenderFns: DataGroup_staticRenderFns }
/* harmony default export */ var components_DataGroup = (DataGroup_esExports);
// CONCATENATED MODULE: ./src/components/DataGroup.vue
function DataGroup_injectStyle (ssrContext) {
  __webpack_require__("mJKS")
}
var DataGroup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataGroup___vue_template_functional__ = false
/* styles */
var DataGroup___vue_styles__ = DataGroup_injectStyle
/* scopeId */
var DataGroup___vue_scopeId__ = "data-v-42c8bc5e"
/* moduleIdentifier (server only) */
var DataGroup___vue_module_identifier__ = null
var DataGroup_Component = DataGroup_normalizeComponent(
  DataGroup,
  components_DataGroup,
  DataGroup___vue_template_functional__,
  DataGroup___vue_styles__,
  DataGroup___vue_scopeId__,
  DataGroup___vue_module_identifier__
)

/* harmony default export */ var src_components_DataGroup = (DataGroup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataGroupList.vue

//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DataGroupList = ({
  name: 'data-group-list',
  components: {
    DataGroup: src_components_DataGroup
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['project']), {
    dataGroups: function dataGroups() {
      return this.project.dataGroups;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357d24f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataGroupList.vue
var DataGroupList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',[_c('el-row',{staticClass:"U--flex-wrap",attrs:{"gutter":20,"no-gutters":"","type":"flex"}},_vm._l((_vm.dataGroups),function(dataGroup,key){return _c('el-col',{key:key,attrs:{"sm":12,"lg":8}},[_c('data-group',{attrs:{"dataGroup":dataGroup}})],1)}))],1)}
var DataGroupList_staticRenderFns = []
var DataGroupList_esExports = { render: DataGroupList_render, staticRenderFns: DataGroupList_staticRenderFns }
/* harmony default export */ var components_DataGroupList = (DataGroupList_esExports);
// CONCATENATED MODULE: ./src/components/DataGroupList.vue
var DataGroupList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataGroupList___vue_template_functional__ = false
/* styles */
var DataGroupList___vue_styles__ = null
/* scopeId */
var DataGroupList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DataGroupList___vue_module_identifier__ = null
var DataGroupList_Component = DataGroupList_normalizeComponent(
  DataGroupList,
  components_DataGroupList,
  DataGroupList___vue_template_functional__,
  DataGroupList___vue_styles__,
  DataGroupList___vue_scopeId__,
  DataGroupList___vue_module_identifier__
)

/* harmony default export */ var src_components_DataGroupList = (DataGroupList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/DataGroups.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var DataGroups = ({
  name: 'data-groups',
  mixins: [redirectIfNewUser],
  components: {
    BtnAddDataGroup: src_components_BtnAddDataGroup,
    DataGroupList: src_components_DataGroupList,
    ModalConfigDataGroup: components_Modal_ConfigDataGroup
  },
  mounted: function mounted() {
    this.$store.commit('setActiveTab', 'dataGroups');
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['modalShowing', 'project']), {
    dataGroupsIsArray: function dataGroupsIsArray() {
      return this.project ? Array.isArray(this.project.dataGroups) : false;
    },
    haveDataGroups: function haveDataGroups() {
      return this.project ? keys_default()(this.project.dataGroups).length > 0 : false;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c20f1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DataGroups.vue
var DataGroups_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[(_vm.dataGroupsIsArray)?_c('el-tag',{staticClass:"el-tag--text-wrap",attrs:{"type":"danger"}},[_vm._v("Not using latest version of datagroups builder, please delete this project")]):_vm._e(),_vm._v(" "),(_vm.modalShowing.addDataGroup)?_c('modal-config-data-group',{attrs:{"mode":"add"}}):_vm._e(),_vm._v(" "),_c('el-row',[_c('btn-add-data-group')],1),_vm._v(" "),_c('el-row',[(_vm.haveDataGroups)?_c('data-group-list'):_vm._e()],1)],1)}
var DataGroups_staticRenderFns = []
var DataGroups_esExports = { render: DataGroups_render, staticRenderFns: DataGroups_staticRenderFns }
/* harmony default export */ var pages_DataGroups = (DataGroups_esExports);
// CONCATENATED MODULE: ./src/pages/DataGroups.vue
function DataGroups_injectStyle (ssrContext) {
  __webpack_require__("SmjX")
}
var DataGroups_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataGroups___vue_template_functional__ = false
/* styles */
var DataGroups___vue_styles__ = DataGroups_injectStyle
/* scopeId */
var DataGroups___vue_scopeId__ = "data-v-d3c20f1e"
/* moduleIdentifier (server only) */
var DataGroups___vue_module_identifier__ = null
var DataGroups_Component = DataGroups_normalizeComponent(
  DataGroups,
  pages_DataGroups,
  DataGroups___vue_template_functional__,
  DataGroups___vue_styles__,
  DataGroups___vue_scopeId__,
  DataGroups___vue_module_identifier__
)

/* harmony default export */ var src_pages_DataGroups = (DataGroups_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserStory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UserStory = ({
  data: function data() {
    return {
      userType: '',
      actionType: '',
      action: '',
      determiner: '',
      dataGroup: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdbd2b5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserStory.vue
var UserStory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',[_c('el-row',[_vm._v("\n    As a\n    "),_c('el-select',{attrs:{"placeholder":"user"},model:{value:(_vm.userType),callback:function ($$v) {_vm.userType=$$v},expression:"userType"}},[_c('el-option',{attrs:{"value":"user"}},[_vm._v("user")])],1),_vm._v("\n    I\n    "),_c('el-select',{attrs:{"placeholder":"can"},model:{value:(_vm.actionType),callback:function ($$v) {_vm.actionType=$$v},expression:"actionType"}},[_c('el-option',{attrs:{"value":"can"}},[_vm._v("can")])],1),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"delete"},model:{value:(_vm.action),callback:function ($$v) {_vm.action=$$v},expression:"action"}},[_c('el-option',{attrs:{"value":"delete"}},[_vm._v("delete")])],1),_vm._v(" "),_c('el-select',{attrs:{"allow-create":"","placeholder":"a"},model:{value:(_vm.determiner),callback:function ($$v) {_vm.determiner=$$v},expression:"determiner"}},[_c('el-option',{attrs:{"value":"a"}},[_vm._v("a")])],1),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"books"},model:{value:(_vm.dataGroup),callback:function ($$v) {_vm.dataGroup=$$v},expression:"dataGroup"}},[_c('el-option',{attrs:{"value":"book"}},[_vm._v("book")])],1)],1)],1)}
var UserStory_staticRenderFns = []
var UserStory_esExports = { render: UserStory_render, staticRenderFns: UserStory_staticRenderFns }
/* harmony default export */ var components_UserStory = (UserStory_esExports);
// CONCATENATED MODULE: ./src/components/UserStory.vue
var UserStory_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserStory___vue_template_functional__ = false
/* styles */
var UserStory___vue_styles__ = null
/* scopeId */
var UserStory___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserStory___vue_module_identifier__ = null
var UserStory_Component = UserStory_normalizeComponent(
  UserStory,
  components_UserStory,
  UserStory___vue_template_functional__,
  UserStory___vue_styles__,
  UserStory___vue_scopeId__,
  UserStory___vue_module_identifier__
)

/* harmony default export */ var src_components_UserStory = (UserStory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/UserStories.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UserStories = ({
  name: 'user-stories',
  mixins: [redirectIfNewUser],
  components: {
    UserStory: src_components_UserStory
  },
  mounted: function mounted() {
    this.$store.commit('setActiveTab', 'userStories');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef4cf9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UserStories.vue
var UserStories_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("Coming soon...")]),_vm._v(" "),(false)?_c('el-row',[_c('user-story')],1):_vm._e()],1)}
var UserStories_staticRenderFns = []
var UserStories_esExports = { render: UserStories_render, staticRenderFns: UserStories_staticRenderFns }
/* harmony default export */ var pages_UserStories = (UserStories_esExports);
// CONCATENATED MODULE: ./src/pages/UserStories.vue
var UserStories_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserStories___vue_template_functional__ = false
/* styles */
var UserStories___vue_styles__ = null
/* scopeId */
var UserStories___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserStories___vue_module_identifier__ = null
var UserStories_Component = UserStories_normalizeComponent(
  UserStories,
  pages_UserStories,
  UserStories___vue_template_functional__,
  UserStories___vue_styles__,
  UserStories___vue_scopeId__,
  UserStories___vue_module_identifier__
)

/* harmony default export */ var src_pages_UserStories = (UserStories_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/UserJourneys.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var UserJourneys = ({
  name: 'user-journeys',
  mixins: [redirectIfNewUser],
  mounted: function mounted() {
    this.$store.commit('setActiveTab', 'userJourneys');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef3111f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UserJourneys.vue
var UserJourneys_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("Coming soon...")])],1)}
var UserJourneys_staticRenderFns = []
var UserJourneys_esExports = { render: UserJourneys_render, staticRenderFns: UserJourneys_staticRenderFns }
/* harmony default export */ var pages_UserJourneys = (UserJourneys_esExports);
// CONCATENATED MODULE: ./src/pages/UserJourneys.vue
var UserJourneys_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserJourneys___vue_template_functional__ = false
/* styles */
var UserJourneys___vue_styles__ = null
/* scopeId */
var UserJourneys___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserJourneys___vue_module_identifier__ = null
var UserJourneys_Component = UserJourneys_normalizeComponent(
  UserJourneys,
  pages_UserJourneys,
  UserJourneys___vue_template_functional__,
  UserJourneys___vue_styles__,
  UserJourneys___vue_scopeId__,
  UserJourneys___vue_module_identifier__
)

/* harmony default export */ var src_pages_UserJourneys = (UserJourneys_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PageNotFound.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var PageNotFound = ({
  name: 'page-not-found'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d032df8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
var PageNotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('h4',[_vm._v("Oops!")]),_vm._v(" "),_c('p',[_vm._v("Page not found")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Go back to home")])],1)}
var PageNotFound_staticRenderFns = []
var PageNotFound_esExports = { render: PageNotFound_render, staticRenderFns: PageNotFound_staticRenderFns }
/* harmony default export */ var pages_PageNotFound = (PageNotFound_esExports);
// CONCATENATED MODULE: ./src/pages/PageNotFound.vue
var PageNotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageNotFound___vue_template_functional__ = false
/* styles */
var PageNotFound___vue_styles__ = null
/* scopeId */
var PageNotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageNotFound___vue_module_identifier__ = null
var PageNotFound_Component = PageNotFound_normalizeComponent(
  PageNotFound,
  pages_PageNotFound,
  PageNotFound___vue_template_functional__,
  PageNotFound___vue_styles__,
  PageNotFound___vue_scopeId__,
  PageNotFound___vue_module_identifier__
)

/* harmony default export */ var src_pages_PageNotFound = (PageNotFound_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js








vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: src_pages_Home
  }, {
    path: '/data',
    name: 'dataGroups',
    component: src_pages_DataGroups
  }, {
    path: '/stories',
    name: 'userStories',
    component: src_pages_UserStories
  }, {
    path: '/journey',
    name: 'userJourneys',
    component: src_pages_UserJourneys
  }, {
    path: '*',
    name: 'PageNotFound',
    component: src_pages_PageNotFound
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js



// eslint-disable-next-line

// http://element.eleme.io/#/en-US/component/notification
// http://element.eleme.io/#/en-US/component/message


/* harmony default export */ var actions = ({
  GET_PROJECTS: function GET_PROJECTS(context) {
    var projects = {};
    keys_default()(localStorage).filter(function (key) {
      return context.getters.regex.isProject.test(key);
    }).forEach(function (key) {
      projects[key] = assign_default()(JSON.parse(localStorage[key]), { id: key });
    });
    context.commit('setProjects', projects);
  },


  /**
   *
   * @param {Object} payload
   */
  GET_PROJECT_DATA: function GET_PROJECT_DATA(context, payload) {
    var project = JSON.parse(localStorage[payload.id]);
    context.commit('updateProjectData', assign_default()({}, project));
  },


  /**
   *
   * @param {Object} project
   */
  SET_PROJECT_DATA: function SET_PROJECT_DATA(context, project) {
    context.commit('localStorage__updateProject', project);
    context.commit('updateProjectData', project);
    if (project.id !== context.getters.project.id) context.commit('setActiveProjectId', project.id);
  },


  /**
   *
   * @param {Object} payload { name: String }
   */
  ADD_PROJECT: function ADD_PROJECT(context, payload) {
    var id = 'proj_' + Date.now();
    var name = payload.name;
    var project = assign_default()({}, context.getters.template.project, { name: name, id: id });
    return new promise_default.a(function (resolve) {
      context.commit('localStorage__addProject', project);
      if (localStorage[id]) {
        resolve();
      }
    }).then(function () {
      context.commit('addProject', assign_default()({}, project));
      context.commit('setActiveProjectId', id);
      return context.state.active.projectId === id;
    }).then(function (stillOk) {
      if (stillOk) {
        element_ui_common["Notification"].success({
          title: 'New project added',
          dangerouslyUseHTMLString: true,
          message: 'Successfully added project <b>' + name + '</b>',
          type: 'success',
          showClose: false,
          duration: 3000,
          position: 'bottom-right'
        });
        context.commit('closeModal');
      }
    });
  },


  /**
   *
   * @param {Object} payload { name: String }
   */
  RENAME_PROJECT: function RENAME_PROJECT(context, project) {
    var origName = context.getters.project.name;
    return new promise_default.a(function (resolve) {
      context.commit('localStorage__updateProject', project);
      if (JSON.parse(localStorage[project.id]).name === project.name) resolve();
    }).then(function () {
      context.commit('renameProject', project);
      return project.name === context.getters.project.name;
    }).then(function (stillOk) {
      if (stillOk) {
        context.commit('closeModal');
        element_ui_common["Notification"].success({
          title: 'Rename successful',
          message: 'Successfully renamed <b>' + origName + '</b> to <b>' + project.name + '</b>',
          dangerouslyUseHTMLString: true,
          type: 'success',
          showClose: false,
          duration: 3000,
          position: 'bottom-right'
        });
      }
    });
  },


  /**
   *
   * @param {Object} payload { id: String }
   */
  DELETE_PROJECT: function DELETE_PROJECT(context, projectId) {
    var name = context.getters.projectMap[projectId];
    return new promise_default.a(function (resolve) {
      context.commit('localStorage__deleteProject', projectId);
      if (!localStorage[projectId]) {
        resolve();
      }
    }).then(function () {
      context.commit('deleteProject', projectId);
      return !context.getters.projectIds.includes(projectId);
    }).then(function (stillOk) {
      if (stillOk && context.getters.isReturningUser) {
        var firstProjectId = context.getters.projectIds[0];
        context.commit('setActiveProjectId', firstProjectId);
        return context.getters.projectId === firstProjectId;
      }
      if (stillOk && context.getters.isNewUser) {
        context.commit('setActiveProjectId', null);
        return true;
      }
    }).then(function (stillOk) {
      router.push({ name: 'home' });
      element_ui_common["Notification"].success({
        title: 'Deletion successful',
        message: 'Project <b>' + name + '</b> successfully deleted',
        dangerouslyUseHTMLString: true,
        type: 'success',
        showClose: false,
        duration: 3000,
        position: 'bottom-right'
      });
    });
  },
  DELETE_ALL_PROJECTS: function DELETE_ALL_PROJECTS(context) {
    return new promise_default.a(function (resolve) {
      context.getters.projectIds.forEach(function (projectId) {
        context.commit('localStorage__deleteProject', projectId);
      });
      var noLsProjects = keys_default()(localStorage).filter(function (key) {
        return context.getters.regex.isProject.test(key);
      }).length === 0;
      if (noLsProjects) {
        resolve();
      }
    }).then(function () {
      context.commit('deleteAllProjects');
      return context.getters.projectIds.length === 0;
    }).then(function (stillOk) {
      if (stillOk) {
        context.commit('setActiveProjectId', null);
        router.push({ name: 'home' });
        element_ui_common["Notification"].success({
          title: 'Deletion successful',
          message: 'All projects successfully deleted',
          type: 'success',
          showClose: false,
          duration: 3000,
          position: 'bottom-right'
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./src/store/mutations.js



/* harmony default export */ var mutations = ({
  localStorage__addProject: function localStorage__addProject(state, project) {
    localStorage[project.id] = stringify_default()(project);
  },
  localStorage__updateProject: function localStorage__updateProject(state, project) {
    localStorage[project.id] = stringify_default()(project);
  },
  localStorage__deleteProject: function localStorage__deleteProject(state, projectId) {
    localStorage.removeItem(projectId);
  },
  setActiveDataGroupId: function setActiveDataGroupId(state, dataGroupId) {
    state.active.dataGroupId = dataGroupId;
  },
  setActiveProjectId: function setActiveProjectId(state, projectId) {
    state.active.projectId = projectId;
  },
  setActiveTab: function setActiveTab(state, tabName) {
    state.active.tab = tabName;
  },
  addProject: function addProject(state, project) {
    vue_esm["default"].set(state.projects, project.id, project);
  },
  renameProject: function renameProject(state, project) {
    state.projects[project.id].name = project.name;
  },
  updateProjectData: function updateProjectData(state, project) {
    state.projects[project.id] = project;
  },
  setProjects: function setProjects(state, projects) {
    state.projects = projects;
  },
  deleteProject: function deleteProject(state, projectId) {
    vue_esm["default"].delete(state.projects, projectId);
  },
  deleteAllProjects: function deleteAllProjects(state) {
    state.projects = {};
  },
  openModal: function openModal(state, modalName) {
    state.active.modal = modalName;
  },
  closeModal: function closeModal(state) {
    state.active.modal = null;
  },
  setBreakpoint: function setBreakpoint(state, breakpoint) {
    state.breakpoint = breakpoint;
  }
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: store_state,
  getters: store_getters,
  actions: actions,
  mutations: mutations
}));
// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/vue-awesome/components/Icon.vue + 2 modules
var Icon = __webpack_require__("D4uH");

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/index.js + 989 modules
var icons = __webpack_require__("D/PP");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// CONCATENATED MODULE: ./src/utils/plugins.js
/* eslint-disable no-unused-vars */


// Element UI



// Vue Awesome



// Vue Analytics



vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].component('icon', Icon["a" /* default */]);
vue_esm["default"].use(vue_analytics_default.a, {
  id: 'UA-118476098-1',
  debug: {
    sendHitTask: "production" === 'production'
  },
  router: router,
  autoTracking: {
    shouldRouterUpdate: function shouldRouterUpdate(to, from) {
      return to.path !== from.path;
    }
  }
});
// CONCATENATED MODULE: ./src/utils/filters.js


vue_esm["default"].filter('capitalise', function (value) {
  if (typeof value !== 'string') {
    console.error('Filter \'capitalise\': String not provided, please provide string');
    return;
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
});
// EXTERNAL MODULE: ./src/assets/style/main.scss
var main = __webpack_require__("2lMp");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Modal/AddProject.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AddProject = ({
  name: 'modal-add-project',
  mixins: [closeModal],
  data: function data() {
    return {
      mode: 'add',
      name: '',
      typing: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['active', 'template']), Object(vuex_esm["c" /* mapGetters */])(['projectNames']), {
    showModal: function showModal() {
      return this.active.modal === 'addProject';
    },
    validationChecks: function validationChecks() {
      return {
        hasName: this.name !== '',
        isTyping: this.typing,
        nameIsUnique: !this.projectNames.includes(this.name)
      };
    },
    errors: function errors() {
      var errors = [];
      var check = this.validationChecks;
      if (check.isTyping) {
        if (!check.hasName) {
          errors.push({ text: 'Your project name cannot be blank', type: 'warning' });
        }
        if (!check.nameIsUnique) {
          errors.push({ text: 'Project name already exists', type: 'danger' });
        }
      }
      return errors;
    },
    validated: function validated() {
      return !values_default()(this.validationChecks).includes(false);
    }
  }),
  methods: {
    addProject: function addProject() {
      if (this.validated) {
        this.$store.dispatch('ADD_PROJECT', { name: this.name });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bda2c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/AddProject.vue
var AddProject_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"add project","visible":_vm.showModal,"width":"300px","close-on-click-modal":false},on:{"close":function($event){_vm.closeModal()}}},[_c('section',{staticClass:"section"},[_c('el-input',{class:{'has-errors': !_vm.validated && _vm.typing},attrs:{"type":"text"},nativeOn:{"~keydown":function($event){_vm.typing = true}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"name"}}),_vm._v(" "),_c('p',{staticClass:"errors"},_vm._l((_vm.errors),function(error,index){return _c('el-tag',{key:index,attrs:{"type":error.type}},[_vm._v(_vm._s(error.text))])}))],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"U--full-width",attrs:{"plain":"","type":"success","disabled":!_vm.validated},on:{"click":_vm.addProject}},[_vm._v("Add project")])],1)])}
var AddProject_staticRenderFns = []
var AddProject_esExports = { render: AddProject_render, staticRenderFns: AddProject_staticRenderFns }
/* harmony default export */ var Modal_AddProject = (AddProject_esExports);
// CONCATENATED MODULE: ./src/components/Modal/AddProject.vue
var AddProject_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AddProject___vue_template_functional__ = false
/* styles */
var AddProject___vue_styles__ = null
/* scopeId */
var AddProject___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AddProject___vue_module_identifier__ = null
var AddProject_Component = AddProject_normalizeComponent(
  AddProject,
  Modal_AddProject,
  AddProject___vue_template_functional__,
  AddProject___vue_styles__,
  AddProject___vue_scopeId__,
  AddProject___vue_module_identifier__
)

/* harmony default export */ var components_Modal_AddProject = (AddProject_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Modal/SwitchProject.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var SwitchProject = ({
  name: 'modal-switch-project',
  mixins: [closeModal],
  created: function created() {
    this.selectedProjectId = this.active.projectId;
  },
  data: function data() {
    return {
      mode: 'switch',
      selectedProjectId: ''
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['active', 'projects']), Object(vuex_esm["c" /* mapGetters */])(['projectMap']), {
    showModal: function showModal() {
      return this.active.modal === 'switchProject';
    },
    validated: function validated() {
      return this.selectedProjectId !== this.active.projectId;
    }
  }),
  methods: {
    switchProject: function switchProject() {
      this.$store.commit('setActiveProjectId', this.selectedProjectId);
      this.closeModal();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ca764f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/SwitchProject.vue
var SwitchProject_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"switch project","visible":_vm.showModal,"width":"300px","close-on-click-modal":false},on:{"close":function($event){_vm.closeModal()}}},[_c('section',{staticClass:"section"},[_c('el-select',{model:{value:(_vm.selectedProjectId),callback:function ($$v) {_vm.selectedProjectId=$$v},expression:"selectedProjectId"}},_vm._l((_vm.projectMap),function(project,key){return _c('el-option',{key:key,attrs:{"label":project,"value":key,"hidden":key === _vm.selectedProjectId}})}))],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"U--full-width",attrs:{"plain":"","type":"success","disabled":!_vm.validated},on:{"click":_vm.switchProject}},[_vm._v("Switch project")])],1)])}
var SwitchProject_staticRenderFns = []
var SwitchProject_esExports = { render: SwitchProject_render, staticRenderFns: SwitchProject_staticRenderFns }
/* harmony default export */ var Modal_SwitchProject = (SwitchProject_esExports);
// CONCATENATED MODULE: ./src/components/Modal/SwitchProject.vue
function SwitchProject_injectStyle (ssrContext) {
  __webpack_require__("J/Ki")
}
var SwitchProject_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SwitchProject___vue_template_functional__ = false
/* styles */
var SwitchProject___vue_styles__ = SwitchProject_injectStyle
/* scopeId */
var SwitchProject___vue_scopeId__ = "data-v-20ca764f"
/* moduleIdentifier (server only) */
var SwitchProject___vue_module_identifier__ = null
var SwitchProject_Component = SwitchProject_normalizeComponent(
  SwitchProject,
  Modal_SwitchProject,
  SwitchProject___vue_template_functional__,
  SwitchProject___vue_styles__,
  SwitchProject___vue_scopeId__,
  SwitchProject___vue_module_identifier__
)

/* harmony default export */ var components_Modal_SwitchProject = (SwitchProject_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Modal/RenameProject.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var RenameProject = ({
  name: 'modal-rename-project',
  mixins: [closeModal],
  created: function created() {
    this.name = {
      original: this.project.name,
      new: this.project.name
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.name = null;
  },
  data: function data() {
    return {
      mode: 'rename',
      name: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['active']), Object(vuex_esm["c" /* mapGetters */])(['projectNames', 'project']), {
    showModal: function showModal() {
      return this.active.modal === 'renameProject';
    },
    validationChecks: function validationChecks() {
      return {
        hasName: this.name.new !== '',
        renamed: this.name.new !== this.name.original,
        nameIsUnique: !this.projectNames.includes(this.name.new)
      };
    },
    errors: function errors() {
      var errors = [];
      var check = this.validationChecks;
      if (check.renamed) {
        if (!check.hasName) {
          errors.push({ text: 'Your project name cannot be blank', type: 'warning' });
        }
        if (!check.nameIsUnique) {
          errors.push({ text: 'Project name already exists', type: 'danger' });
        }
      }
      return errors;
    },
    validated: function validated() {
      return !values_default()(this.validationChecks).includes(false);
    }
  }),
  methods: {
    renameProject: function renameProject() {
      if (this.validated) {
        this.$store.dispatch('RENAME_PROJECT', assign_default()({}, this.project, { name: this.name.new }));
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c82256","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/RenameProject.vue
var RenameProject_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"rename project","visible":_vm.showModal,"width":"300px","close-on-click-modal":false},on:{"close":function($event){_vm.closeModal()}}},[_c('section',{staticClass:"section"},[_c('el-input',{class:{'has-errors': !_vm.validated && _vm.validationChecks.renamed},attrs:{"type":"text"},model:{value:(_vm.name.new),callback:function ($$v) {_vm.$set(_vm.name, "new", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"name.new"}}),_vm._v(" "),_c('p',{staticClass:"errors"},_vm._l((_vm.errors),function(error,index){return _c('el-tag',{key:index,attrs:{"type":error.type}},[_vm._v(_vm._s(error.text))])}))],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"U--full-width",attrs:{"plain":"","type":"success","disabled":!_vm.validated},on:{"click":_vm.renameProject}},[_vm._v("Save")])],1)])}
var RenameProject_staticRenderFns = []
var RenameProject_esExports = { render: RenameProject_render, staticRenderFns: RenameProject_staticRenderFns }
/* harmony default export */ var Modal_RenameProject = (RenameProject_esExports);
// CONCATENATED MODULE: ./src/components/Modal/RenameProject.vue
function RenameProject_injectStyle (ssrContext) {
  __webpack_require__("UASc")
}
var RenameProject_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RenameProject___vue_template_functional__ = false
/* styles */
var RenameProject___vue_styles__ = RenameProject_injectStyle
/* scopeId */
var RenameProject___vue_scopeId__ = "data-v-56c82256"
/* moduleIdentifier (server only) */
var RenameProject___vue_module_identifier__ = null
var RenameProject_Component = RenameProject_normalizeComponent(
  RenameProject,
  Modal_RenameProject,
  RenameProject___vue_template_functional__,
  RenameProject___vue_styles__,
  RenameProject___vue_scopeId__,
  RenameProject___vue_module_identifier__
)

/* harmony default export */ var components_Modal_RenameProject = (RenameProject_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProjectBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ProjectBar = ({
  name: 'project-bar',
  components: {
    ModalAddProject: components_Modal_AddProject,
    ModalSwitchProject: components_Modal_SwitchProject,
    ModalRenameProject: components_Modal_RenameProject
  },
  data: function data() {
    return {
      options: {
        mode: null,
        show: false
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])(['active', 'projects']), Object(vuex_esm["c" /* mapGetters */])(['hasMultipleProjects', 'projectNames', 'modalShowing', 'project']), {
    showOptions: function showOptions() {
      return this.options.mode !== null;
    }
  }),
  methods: {
    openModal: function openModal(modalName) {
      this.$store.commit('openModal', modalName);
    },
    deleteProject: function deleteProject() {
      var _this = this;

      this.$confirm('Are you sure you want to delete this project?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(function () {
        _this.$store.dispatch('DELETE_PROJECT', _this.project.id);
      }).catch(function (err) {
        return err !== 'cancel' ? console.error(err) : null;
      });
    },
    deleteAllProjects: function deleteAllProjects() {
      var _this2 = this;

      this.$confirm('Are you sure you want to delete all of your projects?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(function () {
        _this2.$store.dispatch('DELETE_ALL_PROJECTS');
        _this2.$router.push({ name: 'home' });
      }).catch(function () {});
    },
    modeIs: function modeIs(mode) {
      return mode === this.options.mode;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-302d7ad3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectBar.vue
var ProjectBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-bar"},[_c('h4',{staticClass:"project-name"},[_vm._v(_vm._s(_vm.project ? _vm.project.name : ''))]),_vm._v(" "),_c('el-button',{directives:[{name:"popover",rawName:"v-popover:options",arg:"options"}],staticClass:"icon--info",attrs:{"type":"info","plain":"","icon":"el-icon-more","circle":"","size":"mini"}}),_vm._v(" "),_c('el-popover',{ref:"options",attrs:{"trigger":"hover","placement":"bottom-end","visible-arrow":false,"popper-class":"options"}},[_c('el-menu',[_c('el-menu-item-group',{attrs:{"title":"Project options"}},[_c('el-menu-item',{attrs:{"index":"rename_project"},on:{"click":function($event){_vm.openModal('renameProject')}}},[_vm._v("Rename "),_c('icon',{attrs:{"name":"pencil-alt"}})],1),_vm._v(" "),(_vm.hasMultipleProjects)?_c('el-menu-item',{attrs:{"index":"switch_project"},on:{"click":function($event){_vm.openModal('switchProject')}}},[_vm._v("Switch "),_c('icon',{attrs:{"name":"sign-in-alt"}})],1):_vm._e(),_vm._v(" "),_c('el-menu-item',{staticClass:"danger",attrs:{"index":"delete_project"},on:{"click":function($event){_vm.deleteProject()}}},[_vm._v("Delete "),_c('icon',{attrs:{"name":"trash-alt"}})],1)],1),_vm._v(" "),_c('el-menu-item-group',{attrs:{"title":"App options"}},[_c('el-menu-item',{staticClass:"success",attrs:{"index":"add_project"},on:{"click":function($event){_vm.openModal('addProject')}}},[_vm._v("Add new project "),_c('icon',{attrs:{"name":"plus"}})],1),_vm._v(" "),_c('el-menu-item',{staticClass:"danger",attrs:{"index":"delete_all_projects"},on:{"click":function($event){_vm.deleteAllProjects()}}},[_vm._v("Delete all projects "),_c('icon',{attrs:{"name":"trash-alt"}})],1)],1)],1)],1),_vm._v(" "),(_vm.modalShowing.addProject)?_c('modal-add-project'):_vm._e(),_vm._v(" "),(_vm.modalShowing.switchProject)?_c('modal-switch-project'):_vm._e(),_vm._v(" "),(_vm.modalShowing.renameProject)?_c('modal-rename-project'):_vm._e()],1)}
var ProjectBar_staticRenderFns = []
var ProjectBar_esExports = { render: ProjectBar_render, staticRenderFns: ProjectBar_staticRenderFns }
/* harmony default export */ var components_ProjectBar = (ProjectBar_esExports);
// CONCATENATED MODULE: ./src/components/ProjectBar.vue
function ProjectBar_injectStyle (ssrContext) {
  __webpack_require__("1Wdm")
}
var ProjectBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ProjectBar___vue_template_functional__ = false
/* styles */
var ProjectBar___vue_styles__ = ProjectBar_injectStyle
/* scopeId */
var ProjectBar___vue_scopeId__ = "data-v-302d7ad3"
/* moduleIdentifier (server only) */
var ProjectBar___vue_module_identifier__ = null
var ProjectBar_Component = ProjectBar_normalizeComponent(
  ProjectBar,
  components_ProjectBar,
  ProjectBar___vue_template_functional__,
  ProjectBar___vue_styles__,
  ProjectBar___vue_scopeId__,
  ProjectBar___vue_module_identifier__
)

/* harmony default export */ var src_components_ProjectBar = (ProjectBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/Main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Main = ({
  name: 'main-layout',
  components: {
    ProjectBar: src_components_ProjectBar
  },
  data: function data() {
    return {
      tabs: [{
        name: 'dataGroups',
        label: 'Data Groups'
      }, {
        name: 'userStories',
        label: 'User Stories'
      }, {
        name: 'userJourneys',
        label: 'User Journeys'
      }]
    };
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['setActiveTab']), {
    logit: function logit() {
      this.$message({ message: 'main clicked' });
    },
    clearActiveTab: function clearActiveTab() {
      this.setActiveTab('home');
    },
    changeTab: function changeTab(selectedTab) {
      this.setActiveTab(selectedTab);
      this.$router.push({ name: selectedTab });
    },
    tabIsActive: function tabIsActive(tabName) {
      return tabName === this.active.tab;
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isNewUser', 'isReturningUser', 'breakpointIs', 'devMode']), Object(vuex_esm["e" /* mapState */])(['active', 'breakpoint']), {
    thisYear: function thisYear() {
      // eslint-disable-next-line
      return new Date().getFullYear();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1cdd6c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main-layout"},[(_vm.devMode)?_c('span',{class:("breakpoint--" + _vm.breakpoint)},[_vm._v(_vm._s(_vm.breakpoint))]):_vm._e(),_vm._v(" "),_c('el-header',[_c('router-link',{class:['title', {'centered-title': _vm.isNewUser}],attrs:{"tag":"p","to":"/"},nativeOn:{"click":function($event){_vm.clearActiveTab()}}},[(_vm.breakpointIs('xs') && _vm.isReturningUser)?_c('icon',{attrs:{"name":"home","scale":"1.5"}}):_c('span',[_vm._v("User Story Builder")])],1),_vm._v(" "),(_vm.isReturningUser)?_c('project-bar'):_vm._e()],1),_vm._v(" "),_c('el-main',[(_vm.isReturningUser)?[_c('div',{staticClass:"button-bar"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.name,class:['button-bar__button', { active: _vm.tabIsActive(tab.name) }],on:{"click":function($event){_vm.changeTab(tab.name)}}},[_vm._v("\n          "+_vm._s(tab.label)+"\n        ")])})),_vm._v(" "),_vm._t("default")]:_vm._e(),_vm._v(" "),(_vm.isNewUser)?[_c('h1',[_vm._v("Welcome!")]),_vm._v(" "),_vm._t("default")]:_vm._e()],2),_vm._v(" "),_c('el-footer',[_c('span',[_vm._v("EmilyRosina © "+_vm._s(_vm.thisYear))]),_vm._v(" "),_c('a',{staticClass:"github",attrs:{"href":"https://github.com/EmilyRosina/user-story-builder","target":"_blank"}},[_c('icon',{attrs:{"name":"brands/github","scale":"2.5"}})],1)])],1)}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var layouts_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/layouts/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("Vh2T")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = "data-v-e1cdd6c8"
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  layouts_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var src_layouts_Main = (Main_Component.exports);

// CONCATENATED MODULE: ./src/utils/globalComponents.js




var components = [src_layouts_Main];

components.forEach(function (component) {
  vue_esm["default"].component(component.name, component);
});
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable no-unused-vars */












vue_esm["default"].config.devtools = true;
vue_esm["default"].config.productionTip = false;
vue_esm["default"].mixin(mixins_objectsMatch);

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "SmjX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UASc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vh2T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iedY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e47c8cde4eb787fffca6.js